import {
    UPDATE_ACCESS_POINT,
    UPDATE_ACCESS_POINT_FAILURE,
    UPDATE_ACCESS_POINT_SUCCESS,
} from 'store/actions/types';

export const updateAccesPoint = (payload) => {
    return {
        type: UPDATE_ACCESS_POINT,
        payload: payload,
    };
};

export const updateAccessPointFailure = (error) => {
    return {
        type: UPDATE_ACCESS_POINT_FAILURE,
        error: error,
    };
};
export const updateAccessPointSuccess = (response) => {
    return {
        type: UPDATE_ACCESS_POINT_SUCCESS,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/updateAccessPoint.js